import {isNotNil, round} from 'ramda-adjunct';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

const PERCENTAGE_MULTIPLIER = 100;

export const getVehicleDetailPosition = (
  measureCarRank: number | Nullish,
  measureCountRelevantCar: number | Nullish,
  pricePercentile: number | Nullish
) => [
  isNotNil(measureCarRank) || isNotNil(measureCountRelevantCar)
    ? `${measureCarRank ?? '?'}/${measureCountRelevantCar ?? '?'}`
    : EMPTY_PLACEHOLDER,
  isNotNil(pricePercentile) ? `${round(pricePercentile * PERCENTAGE_MULTIPLIER)}%` : '',
];
